import { scrubLogs } from 'common/log-utils';
import { FetchResponse } from 'types/fetch';
import getBrowserName from '../browser-name';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type LogEventOptions = {
  correlationId: string;
  request: Record<string, unknown>;
};

export default function fetchLogEvent({
  correlationId,
  request
}: LogEventOptions): FetchResponse<void> {
  return fetchReq({
    body: {
      Browser: getBrowserName(),
      CO: 'VISA_SDK_V2',
      CR: correlationId,
      E: 'VISA_UNKNOWN_EVENT',
      LL: 'INFO',
      O: 'JSSDK',
      OS: navigator.platform,
      RTY: 'OUT',
      T: 'E',
      ...scrubLogs(request)
    },
    headers: {
      'X-CORRELATION-ID': correlationId
    },
    method: 'POST',
    url: endpoints.eventLogging,
    waitForVbaToken: false
  });
}
